<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19.092"
    height="19.092"
    viewBox="0 0 19.092 19.092"
  >
    <g id="add-emp" transform="translate(-281.409 -112.449) rotate(-45)">
      <g id="plus" transform="translate(-351.527 -19.527)">
        <line
          id="Линия_34"
          data-name="Линия 34"
          y2="24"
          transform="translate(471 299.527)"
          fill="none"
          stroke="#000"
          stroke-linecap="round"
          stroke-width="1.5"
        />
        <line
          id="Линия_35"
          data-name="Линия 35"
          y1="24"
          transform="translate(483 311.527) rotate(90)"
          fill="none"
          stroke="#000"
          stroke-linecap="round"
          stroke-width="1.5"
        />
      </g>
    </g>
  </svg>
</template>
